export const getSelectionGroupDisplayClasses: (
  hiddenLabel?: boolean,
  row?: boolean
) => Record<string, boolean | undefined> = (hiddenLabel, row) => ({
  'dense-top': hiddenLabel,
  'f-row': row,
});
